// @ts-nocheck
import * as effects from 'redux-saga/effects';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';

export function* reopenSockets() {
  try {
    yield effects.put(wsActions.setSocketsStatus('CLOSED'));
    yield effects.put(wsActions.setClosedSockets(true));
    yield effects.put(wsActions.setOpenedSockets(false));
  } catch (e) {
    yield handleError(e);
  }
}
